import(/* webpackMode: "eager" */ "/home/runner/workspace/artifacts/light-hero/app/[[...slug]]/page.tsx");
